import { render, staticRenderFns } from "./kTojBuyTypeList.vue?vue&type=template&id=3720de5e&"
import script from "./kTojBuyTypeList.vue?vue&type=script&lang=js&"
export * from "./kTojBuyTypeList.vue?vue&type=script&lang=js&"
import style0 from "./kTojBuyTypeList.vue?vue&type=style&index=0&id=3720de5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports